// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"538":"recorder","983":"profiler"}[chunkId] || chunkId) + "." + {"538":"bcde959d","787":"b29a6f96","983":"a88ee782"}[chunkId] + ".chunk.js";
};